<div style="padding: 30px 10px 10px 10px; overflow-x: hidden;">
    <mat-label>
        <mat-icon>settings_suggest</mat-icon>
        <span class="headerIcon">{{ 'general.aiModels' | transloco }}</span>
    </mat-label>
    <br/>
    <br/>

    <div style="display: flex; flex-direction: column; gap: 10px; max-width: 400px; padding-left: 30px">
        <div style="display: flex; align-items: center; gap: 10px;">
            <label style="width: 100px">Chat:</label>
            <select [(ngModel)]="aiSettings.chat" (change)="onAssistantChange()" style="width: 150px">
                <option *ngFor="let option of chatOptions" [value]="option.name">
                    {{ option.label }}
                </option>
            </select>
        </div>

        <div style="display: flex; align-items: center; gap: 10px;">
            <label style="width: 100px">Create image:</label>
            <select [(ngModel)]="aiSettings.createImage" (change)="onAssistantChange()" style="width: 150px">
                <option *ngFor="let option of createImageOptions" [value]="option.name">
                    {{ option.label }}
                </option>
            </select>
        </div>

        <div style="display: flex; align-items: center; gap: 10px;">
            <label style="width: 100px">Edit image:</label>
            <select [(ngModel)]="aiSettings.editImage" (change)="onAssistantChange()" style="width: 150px">
                <option *ngFor="let option of editImageOptions" [value]="option.name">
                    {{ option.label }}
                </option>
            </select>
        </div>

        <div style="display: flex; align-items: center; gap: 10px;">
            <label style="width: 100px">Create video:</label>
            <label style="width: 150px">not supported yet</label>
            <!--
            <select [(ngModel)]="aiSettings.createVideo" (change)="onAssistantChange()" style="width: 150px">
                <option *ngFor="let option of createVideoOptions" [value]="option.name">
                    {{ option.label }}
                </option>
            </select>
            -->
        </div>
<!--
        <div style="display: flex; align-items: center; gap: 10px;">
            <label style="width: 100px">Edit video:</label>
            <label style="width: 150px">not supported yet</label>
            <select [(ngModel)]="aiSettings.editVideo" (change)="onAssistantChange()" style="width: 150px">
                <option *ngFor="let option of editVideoOptions" [value]="option.name">
                    {{ option.label }}
                </option>
            </select>
        </div>
-->
    </div>
    <br/>
    <br/>
    <div style="margin-left: -5px">
        <mat-checkbox [(ngModel)]="aiSettings.autoHide" (change)="onAssistantChange()">Auto hide when finished
        </mat-checkbox>
        <br/>
        <mat-checkbox [(ngModel)]="aiSettings.showThinking" (change)="onAssistantChange()">show thinking process
        </mat-checkbox>
    </div>
</div>